import { render, staticRenderFns } from "./ValuationResultItem.vue?vue&type=template&id=6a108ab4&scoped=true&"
import script from "./ValuationResultItem.vue?vue&type=script&lang=js&"
export * from "./ValuationResultItem.vue?vue&type=script&lang=js&"
import style0 from "./ValuationResultItem.vue?vue&type=style&index=0&id=6a108ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a108ab4",
  null
  
)

export default component.exports